import { Address } from 'viem';

import { normalizeAddress } from '@shared/helpers/web3/address';
import { ParsedWeiAmount, parseWei } from '@shared/helpers/web3/formatters';

import { PredictionDirection } from '../PredictionDirection';
import { AdjacentRound } from './adjacentRound';

export type PredictionParticipants = Record<string, bigint>;

type PredictionRoundParticipated = {
  isParticipated: true;
  amount: ParsedWeiAmount;
  direction: PredictionDirection;
  directionTitle: string;
  wonAmount: ParsedWeiAmount;
};

type PredictionRoundNotParticipated = {
  isParticipated: false;
  amount?: never;
  direction?: never;
  directionTitle?: never;
  wonAmount?: never;
};

export type PredictionRoundParticipation =
  | PredictionRoundParticipated
  | PredictionRoundNotParticipated;

type GetParticipationInfoProps = {
  round: AdjacentRound;
  wallet?: Address;
};

export const getParticipationInfo = ({
  round,
  wallet,
}: GetParticipationInfoProps): PredictionRoundParticipation => {
  if (!wallet) {
    return {
      isParticipated: false,
    };
  }

  const normalizedWallet = normalizeAddress(wallet);
  const upAmount = round.upParticipants[normalizedWallet];
  const downAmount = round.downParticipants[normalizedWallet];
  const wonAmount = round.winParticipants[normalizedWallet];
  const isParticipated = !!upAmount || !!downAmount;
  let direction = PredictionDirection.UP;

  if (downAmount) {
    direction = PredictionDirection.DOWN;
  }

  if (!isParticipated) {
    return {
      isParticipated,
    };
  }

  const amount = direction === PredictionDirection.DOWN ? downAmount : upAmount;

  return {
    isParticipated,
    amount: parseWei({ wei: amount, tokenName: 'USDT', formatOptions: { stableToDollar: false } }),
    direction,
    directionTitle: direction === PredictionDirection.DOWN ? 'Down' : 'Up',
    wonAmount: parseWei({
      wei: wonAmount,
      tokenName: 'USDT',
      formatOptions: { stableToDollar: false },
    }),
  };
};
